import actionCreatorFactory from 'typescript-fsa';

import reduxConfig from '../../../store/config';
import { BinControlUnit } from './binControl.types';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/binControl');

export const getBinControlunitsList = actionCreator.async<void, BinControlUnit[]>('GET_BIN_CONTROL_UNITS_LIST');
export const createBinControlUnit = actionCreator.async<Partial<BinControlUnit>, BinControlUnit>(
  'CREATE_BIN_CONTROL_UNITS_LIST',
);
export const editBinControlUnit = actionCreator.async<Partial<BinControlUnit>, BinControlUnit>(
  'EDIT_BIN_CONTROL_UNITS_LIST',
);
export const deleteBinControlUnit = actionCreator.async<string, void>('DELETE_BIN_CONTROL_UNITS_LIST');
export const saveBinControlUnitsForm = actionCreator.async<
  {
    updatedBinControlUnits: BinControlUnit[];
    createdBinControlUnits: BinControlUnit[];
    deletedBinControlUnits: BinControlUnit[];
  },
  void
>('SAVE_BIN_CONTROL_UNITS_FORM');
